import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { InnModalPopup } from "../innModalPopup";
import calenderIcon from "../../assets/images/top-calender-icon.svg";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import phoneIcon from "../../assets/images/contact-phone-icon.svg";
import emailIcon from "../../assets/images/contact-email-icon.svg";
import backArrowIcon from "../../assets/images/top-back-arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { encodedStringData, navigation, propertyDetails, reservationData, setHomeNavigate } from "../../reducer/selfCheckinSlice";
import { InnLoader } from "../innLoader";
import moment from "moment";

function HomeInfo() {

  const [navigationData, setNavigationData] = useState();
  const [showCalenderData, setShowCalenderData] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const propertyObj = useSelector(propertyDetails);
  const guestDetailObj = useSelector(reservationData)
  const navigationObj = useSelector(navigation);
  const encodeStringObj = useSelector(encodedStringData)
  const route = useNavigate();
  const dispatch = useDispatch();
  const wait = timeOut => {
    return new Promise(resolve => setTimeout(resolve, timeOut));
  }
  useEffect(() => {
    setIsActive(true);
    if (propertyObj === undefined) {
      route("/Unauthorised")
  }
    setNavigationData(navigationObj);
    wait(1000).then(() => setIsActive(false))
  }, []);

  const onClickBackArrow = () => {
    if (navigationData.homeNavigate === "FromHomePage") {
      route(`/HomePage/${encodeStringObj}`)
      dispatch(setHomeNavigate(""));
    }
    else if (navigationData.homeNavigate === "FromRegistrationPage") {
      route("/Registration")
      dispatch(setHomeNavigate(""));
    }
    else if (navigationData.homeNavigate === "FromRegistration1Page") {
      route("/Registration1")
      dispatch(setHomeNavigate(""));
    }
    else if (navigationData.homeNavigate === "ThankYouPage") {
      route("/ThankYou")
      dispatch(setHomeNavigate(""));
    }
    else if (navigationData.homeNavigate === "FromPreviewExamplePage") {
      route("/PreviewExample")
      dispatch(setHomeNavigate(""));
    }
  }


  return (
    <div>
      <InnLoader className={isActive ? "active" : null}></InnLoader>
      <div>
        <div className="top-blue-bg">
          {/* <Link to={"/HomePage"}> */}
          <div className="top-back-arrow">
            <img src={backArrowIcon} onClick={() => { onClickBackArrow() }} />
          </div>
          {/* </Link> */}
          <div className="top-blue-hdng">
            <h2>Contact us</h2>
          </div>
          <div className="top-blue-bg-icon">
            <div>
              <img
                onClick={() => setShowCalenderData(!showCalenderData)}
                src={calenderIcon} />
            </div>

            <Link to="/HomeInfo">
              <div style={{ marginLeft: 10 }}>
                <img src={buldingIcon} />
              </div>
            </Link>
          </div>
        </div>
        <div className="contact-us-bg" style={{ marginTop: 124 }}>
          <h3>{propertyObj?.Name} - {propertyObj?.CityName}</h3>
          <h5>{propertyObj?.Address} {propertyObj?.CityName} - {propertyObj?.Pin} {propertyObj?.StateName}, {propertyObj?.CountryName}</h5>
          <div className="reg-detail m-tp10 m-btm20">
            <button className="drk-blue-btn">
              <a target="_blank" href={"https://www.google.com/maps/?q=" + propertyObj?.Name + propertyObj?.CityName}>
                Click To Get Hotel Direction
              </a>
            </button>
          </div>
          <div className="text-center"></div>
          <div className="contact-detail">
            <div>
              <div>
                <a href={"tel:" + propertyObj?.HotelMobileNo}>
                  <img src={phoneIcon} />
                </a>
              </div>
              <h5>
                Phone <br />
                <a href={"tel:" + propertyObj?.HotelMobileNo}>
                  <span>{propertyObj?.HotelMobileNo}</span>
                </a>
              </h5>
            </div>
            <div>
              <div>
                <a href={"tel:" + propertyObj?.Contact_Mobile}>
                  <img src={phoneIcon} />
                </a>
              </div>
              <h5>
                Phone 2 <br />
                <a href={"tel:" + propertyObj?.Contact_Mobile}>
                  <span>{propertyObj?.Contact_Mobile}</span>
                </a>
              </h5>
            </div>
            <div>
              <div>
                <a href={"mailto:" + propertyObj?.Contact_Email}>
                  <img src={emailIcon} />
                </a>
              </div>
              <h5>
                Email <br />
                <a href={"mailto:" + propertyObj?.Contact_Email}>
                  <span>{propertyObj?.Contact_Email}</span>
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div className="overlay">
        <div className="overlay-background"></div>
        {/* <div className="overlay-content"><span className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
      </div>
      <div className="hidden">
        <div className="loader-overlay"></div>
      </div>
      {showCalenderData ? (
        <InnModalPopup Onclose={() => setShowCalenderData(false)}>
          <div class="modal-content x-small-popup">
            <div
              id="myModal3"
              tabindex="-1"
              role="dialog"
              aria-labelledby="myModalLabel3"
              class="model-popup"
            >
              <div role="document">
                <div class="reg-detail text-left">
                  <h2>{guestDetailObj?.GuestName}</h2>
                </div>
                <div class="reg-detail p-btm30">
                  <div class="wdth50 bdr-rgt">
                    <p>{moment(new Date(guestDetailObj?.Arrival_Date)).format("DD MMM")} - {moment(new Date(guestDetailObj?.Departure_Date)).format("DD MMM")}</p>
                    <p>{guestDetailObj?.No_Of_Nights} Nights</p>
                  </div>
                  <div class="wdth50">
                    <p class="text-right">Booking No: {guestDetailObj?.Booking_No}</p>
                    <p class="text-right">{guestDetailObj?.No_Of_Rooms} Room {guestDetailObj?.Adult} Adults</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </InnModalPopup>
      ) : null}
    </div>
  );
}

export default HomeInfo;
